import React, { FC } from 'react'
import styled from 'styled-components'

import { PageLayoutContainer } from '../../../lib/page-layout-container'
import { Header } from '../../../lib/header'
import { useUserGetOwnedChargePointsQuery } from '../../../common/redux/api/web-api'
import ChargePointExpandOptions from '../../../lib/chargePointExpandOptions'
import { WidgetLayout } from '../../../lib/widget-layout'
import LinkButton from '../../../common/features/support/LinkButton'
import Text from '../../../ui/Text'
import PartnerInfoItem from '../../../common/features/support/PartnerInfoItem'
import PartnerInfoCard from '../../../common/features/support/PartnerInfoCard'
import useText from '../../../common/hooks/useText'

const SSupportDetailsMessage = styled.label`
    font-size: 16px;
    line-height: 24px;
    display: block;
    margin-bottom: 40px;
`

export const UserAppSupportPage: FC = () => {
    const text = useText()
    const { data: chargePoints, isLoading } = useUserGetOwnedChargePointsQuery({
        expand: ChargePointExpandOptions.PartnerInfo,
    })

    const chargersWithPartnerInfo = chargePoints?.filter((charger) => charger.partnerInfo) ?? []

    const renderItem = () => {
        if (chargersWithPartnerInfo.length === 0) {
            return null
        }
        if (chargersWithPartnerInfo.length === 1) {
            const partnerInfo = chargersWithPartnerInfo[0].partnerInfo
            return <PartnerInfoCard name={partnerInfo?.name} email={partnerInfo?.email} phone={partnerInfo?.phone} />
        } else {
            return chargersWithPartnerInfo.map((charger) => (
                <PartnerInfoItem
                    key={charger.id}
                    name={charger.partnerInfo?.name}
                    email={charger.partnerInfo?.email}
                    phone={charger.partnerInfo?.phone}
                    chargerName={charger.name ?? charger.id}
                    chargerSerialNumber={charger.id}
                />
            ))
        }
    }

    return (
        <PageLayoutContainer>
            <div className="row">
                <div className="col-xs-12">
                    <Header code="lblSupport" className="supportPage" size="lg" dataTestId="header-support" />
                </div>
                <div className="col-xs-12 col-md-7 margin-top-small">
                    {!isLoading ? (
                        <WidgetLayout>
                            {chargersWithPartnerInfo.length > 0 ? (
                                <div className="margin-bottom-large">
                                    <SSupportDetailsMessage data-testid="support-details-message">
                                        {text('msgDetailsOfSupportProvider')}
                                    </SSupportDetailsMessage>
                                    {renderItem()}
                                </div>
                            ) : null}
                            <>
                                <Text code={'lblFaq'} />
                                <LinkButton
                                    dataTestId="link-charge-amps-support-page"
                                    titleCode="lblChargeAmpsSupportPage"
                                    href={`https://www.chargeamps.com/${text('linkSupport')}`}
                                />
                                <LinkButton
                                    dataTestId="link-charge-amps-help-center-page"
                                    titleCode="lblChargeAmpsHelpCenter"
                                    href={text('linkHelpCenter')}
                                />
                            </>
                        </WidgetLayout>
                    ) : null}
                    {isLoading && <div className="shimmer-container shimmer-large" data-testid="loader"></div>}
                </div>
            </div>
        </PageLayoutContainer>
    )
}
